
import { Component, Prop, Vue } from 'vue-property-decorator'
import CharField from './CharField.vue'
@Component({
  components: { CharField }
})
export default class PasswordField extends Vue {
  @Prop() label!: string
  @Prop() value!: string
  @Prop() error!: string
  @Prop() placeHolder!: string
  @Prop() required!: boolean
  @Prop() readOnly!: boolean
  @Prop() isDisabled!: boolean
  @Prop() charLimit!: number
  @Prop() charLimitInfo!: boolean
  @Prop() labelBackgroundColor!: string | null
  @Prop() inputFieldBackgroundColor!: string | null
  @Prop() hintHtml!: string
  @Prop() passwordState!: 'weak' | 'medium' | 'strong' | 'notMatching' | null

  showPassword = false

  togglePassword (): void {
    this.showPassword = !this.showPassword
  }
}
